import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import ReactPaginate from "react-paginate";
import mediaImage from './../../assets/images/user.jpg';
import CalendarIcon from './../../icons/calendaricon';
import TwitterIcon from './../../icons/twittericon';
import InstaIcon from './../../icons/instaicon';
import TextField from './../../component/TextField';
import CheckBox from './../../component/CheckBox';
import Dropdown from './../../component/Dropdown';
import DropdownMaster from './../../component/DropdownMaster';
import DraggerIcon from './../../icons/draggericon';
import FpgMinusIcon from './../../icons/fpgminusicon';
import FpgPlusIcon from './../../icons/fpgplusicon';
import AddFileIcon from './../../icons/plusicon';
import CopyIcon from './../../icons/copyicon';
import AddarrowIcon from './../../icons/addarrow';
import Select from 'react-select';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ModalMessage from '../../component/ModalMessage';
import ErrorPopUp from '../../component/errorPopUp';
import Cookies from 'universal-cookie';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//Service import
import service from '../../services'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//moment import
import moment from "moment-timezone";

//  Date Picker
import DatePicker from "react-datepicker";
import Loader from '../../component/loader';
import UploadForm from './../../component/UploadForm';
import PopUpCustomAll from './../../component/fpg/create/popUpCustomAll';


import { Player, ControlBar, PlayToggle } from "video-react";
import TextEditor from '../../component/TextEditor';
import DeletefileIcon from '../../icons/DeletefileIcon';
import PlusIcon from './../../icons/plusicon';
import VideoOnlyUpload from '../VideoOnlyUpload';
import VideoImageFile from './../../component/VideoImageFile';
import { DEFAULT_VERSION } from 'redux-persist';
import commonImage from '../../commonImage';

let sub;

const cookies = new Cookies();

// fake data generator
const getItems = (count) =>
    Array.from({ length: count }, (v, k) => k).map((k) => ({
        id: `item-${k}`,
        content: `item ${k}`,
    }));
const EXT_IMAGES = /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i;
const EXT_VIDEO = /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i;
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
const mapStateToProps = state => ({
    filmEditId: state.filmEditId,
    profileName: state.profileName,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};



class CreateFilm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            sponsorLogoDetails: false,
            awardSponsorLogoDetails: false,
            screeninfpopup: false,
            screeninfpopupPre: false,
            sponserlogo: false,
            deleteImageId: '',
            deleteImagePopup: false,
            filmDisabled: false,
            messageModal: false,
            isDraggable: false,
            meetImagePreloader: false,
            filmId: '',
            screeningType: [
                // {_id: '4', name: 'On demand' },
                { _id: '1', name: 'Premiere' },
                { _id: '2', name: 'Second Screening' },
                { _id: '3', name: 'Award winner' }
            ],
            playerTypeOption:[{_id:2,name:'Eventive'}],
            shortDateTime: [],
            dropDownRemoveForIndiesSeries: false,
            errorPopup: false,
            discardPopup: false,
            errorMsg: '',
            imageErr: '',
            file: null,
            selectedOption: null,
            hours: '7',
            minutes: '30',
            state: 'AM',
            publishModal: false,
            optiondata: ["Alberta", "British", "Manitoba", "Executive Producers", "Newfoundland"],
            previewRecordFilm: [],
            countryType: [ "Select Country", "United States", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "The Democratic Republic of Congo", "Cook Islands", "Costa Rica", "Ivory Coast", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "England", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji Islands", "Finland", "France", "French Guiana", "French Polynesia", "French Southern territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Isle of Man", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova", "Monaco", "Mongolia", "Montserrat", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Macedonia", "North Korea", "Northern Ireland", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Scotland", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Korea", "South Sudan", "Spain", "SriLanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wales", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe",],
            shortFlim: false,
            indiesFlim: false,
            shortProgramme1: '',
            shortProgramme: '',
            shortProgrammeDrop: '',
            fileMakerId: "",
            shift72Id: "",
            eventiveId:'',
            playerType:2,
            access: "",
            title: "",
            description: EditorState.createEmpty(),
            shortDescription: EditorState.createEmpty(),
            editorStateExplicitContent: EditorState.createEmpty(),
            // images: [],
            company: '',
            credits: [{
                _id: Math.random(),
                creditId: '',
                creditType: [{
                    _id: Math.random(),
                    creditsInsideType: ''
                }]
            }],
            year: "",
            category: "",
            awardCategory: "",
            awardSponsorLogo: "",
            votes: "",
            // isAudioDescription: false,
            audioDescriptionShift72Id: "",
            audioDescriptionEventiveId: "",
            isExplicitContent: false,
            explicitContent: EditorState.createEmpty(),
            sponsorLogo: "",
            screeningMoreInfoTitle: "",
            screeningMoreInfo: EditorState.createEmpty(),
            country: "",
            runTime: '',
            website: "",
            contact: [
                {
                    _id: Math.random(),
                    emailPhone: '',
                }
            ],
            genre: [],
            interestTrack: [],
            accessibility: [],
            dateTime: [
                {
                    _id: Math.random(),
                    screeningType: { _id: '1', name: 'Premiere' },
                    date: new Date(),
                    hours: { value: '7', label: '7' },
                    minutes: { value: '30', label: '30' },
                    state: { value: 'AM', label: 'AM' },
                    premierScreening: {
                        waitingRoomTrailerShift72Id: "",
                        isSponsor: false,
                        sponsorLogo: ""
                    }
                }
            ],
            // qaReplayLink: "",
            teamConnection: [{
                name: "",
                email: ""
            }],
            artist: [{
                _id: Math.random(),
                image: "",
                name: "",
                description: EditorState.createEmpty(),
                youtube: "",
                instagram: "",
                twitter: "",
            }],
            maxNumberOfRules: 4,
            creditLabel: [],
            images: [
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                }
            ]

        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                urlValidation: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                websiteValid: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([a-zA-Z '. -]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                companyName: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 ' , . & !]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                }
            }
        });
        this.apiserve = new service();

    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    componentDidMount = () => {
        if (this.props.match.params && this.props.match.params.id) {
            this.setState({ filmId: this.props.match.params.id ,isImage:true})
            this.apiserve.sendevent("privateScreeningPartner|film|getAllDetail", {
                filmId: this.props.match.params.id
            });
            this.apiserve.sendevent("fpg|shortProgramme|dropList|get", {});
        }
        this.apiserve.sendevent("user|sff|getAllInitialForRedis", {});



        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "privateScreeningPartner|film|create":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            filmDisabled: true,
                        })
                        this.apiserve.success('Created successfully.')
                        this.props.history.push('/partners-film-view')
                    }
                    else {
                        this.setState({
                            filmDisabled: false,
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                        // this.apiserve.error(response.data.data)
                    }

                    break;
                case "user|sff|getAllInitialForRedis":
                    this.setState({
                        film: response.data.film,
                    })
                    break;

                case "privateScreeningPartner|film|edit":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            filmDisabled: true,
                        })
                        this.apiserve.success('Updated successfully.')
                        setTimeout(() => {
                            this.props.history.push('/partner-film-detail-view/' + this.state.filmId)
                        }, 500);
                    }
                    else {
                        this.setState({
                            filmDisabled: false,
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })

                        // this.apiserve.error(response.data.error)
                    }

                    break;
                case "privateScreeningPartner|film|getAllDetail":
                    if (!response.error) {

                        var creditData = response.data && response.data.credits.map(item => {

                            var credits = {
                                _id: item._id,
                                creditId: { value: item.creditId._id, label: item.creditId.name }, creditType: [],
                                identifier:item.identifier,
                                creditTypeValue:item.creditTypeValue
                            }
                            item && item.creditType.map(creditList => {
                                var creditType = {
                                    _id: creditList._id,
                                    creditsInsideType: creditList.creditsInsideType
                                }
                                credits && credits.creditType.push(creditType)
                            })
                            return credits
                        })

                        var genreData = response.data && response.data.genre.map(item => {
                            var genre = {
                                value: item._id, label: item.name
                            }
                            return genre
                        })

                        var interestTrackData = response.data && response.data.interestTrack.map(item => {
                            var interestTrack = {
                                value: item._id, label: item.name
                            }
                            return interestTrack
                        })

                        var accessibilityData = response.data && response.data.accessibility.map(item => {
                            var accessibility = {
                                value: item._id, label: item.name
                            }
                            return accessibility
                        })

                        var images = response.data && response.data.images.map((image) => {
                            var imageData = {
                                _id: Math.random(),
                                inSite: image.inSite,
                                link: image.link
                            }
                            return imageData
                        })

                        if (response.data.description) {
                            const blocksFromHtml = htmlToDraft(response.data.description);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            const editorState = EditorState.createWithContent(contentState);
                            this.setState({
                                editorState: editorState,
                            })
                        }
                        let editorStateExplicitContent;
                        if (response.data.explicitContent) {
                            let blocksFromHtml = htmlToDraft(response.data.explicitContent);
                            let { contentBlocks, entityMap } = blocksFromHtml;
                            let contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            editorStateExplicitContent = EditorState.createWithContent(contentState);
                        }
                        let editorStateScreeningMoreInfo;

                        if (response.data.screeningMoreInfo) {
                            let blocksFromHtml = htmlToDraft(response.data.screeningMoreInfo);
                            let { contentBlocks, entityMap } = blocksFromHtml;
                            let contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            editorStateScreeningMoreInfo = EditorState.createWithContent(contentState);
                        }
                        this.setState({
                            filmId: response.data._id,
                            previewRecordFilm: response.data,
                            mediaId: response.data.mediaId,
                            fileMakerId: response.data.fileMakerId,
                            // shift72Id: response.data.shift72Id,
                            // playerType: response.data.playerType,
                            eventiveId: response.data.eventiveId,
                            access: { value: response.data.access && response.data.access._id, label: response.data.access && response.data.access.name },
                            title: response.data.title,
                            company: response.data.company,
                            images: images,
                            credits: creditData,
                            year: response.data.year,
                            category: { value: response.data.category && response.data.category._id, label: response.data.category && response.data.category.name },
                            // isAudioDescription: response.data.isAudioDescription,
                            isExplicitContent: response.data.isExplicitContent,
                            audioDescriptionShift72Id: response.data.audioDescriptionShift72Id,
                            audioDescriptionEventiveId: response.data.audioDescriptionEventiveId,
                            editorStateExplicitContent: editorStateExplicitContent,
                            explicitContent: response.data.explicitContent,
                            screeningMoreInfoTitle: response.data.screeningMoreInfoTitle,
                            editorStateScreeningMoreInfo: editorStateScreeningMoreInfo,
                            country: response.data.country,
                            runTime: response.data.runTime,
                            website: response.data.website,
                            contact: response.data.contact,
                            genre: genreData,
                            interestTrack: interestTrackData,
                            accessibility: accessibilityData,
                            // qaReplayLink: response.data.qaReplayLink,

                        }, () => {
                            if (response.data.shortProgramme && response.data.shortProgramme._id && response.data.shortProgramme) {

                                this.setState({
                                    shortFlim: true,
                                    shortDateTime: [...this.state.shortDateTime, response.data && response.data.shortProgramme]
                                })
                            }
                            if (response.data.category && response.data.category.type === 3) {
                                this.setState({
                                    indiesFlim: true,
                                })
                            }
                            this.forceUpdate();
                        })
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                case "fpg|shortProgramme|dropList|get":
                    if (!response.error) {
                        var dataShort = response && response.data.map(item => {
                            var shortProgramme = {
                                _id: item._id, name: item.name, date: item.date
                            }
                            return shortProgramme
                        })
                        this.setState({
                            shortProgramme: dataShort
                        })
                    }

                    break;

                default:
                    break;
            }
        });
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState,
        });
    };

    onEditorStateChangeShort = (editorStateShort) => {
        this.setState({
            editorStateShort,
        });
    };

    onEditorStateChangeExplicitContent = (editorStateExplicitContent) => {
        this.setState({
            editorStateExplicitContent,
        });
    };

    onEditorStateChangeScreeningMoreInfo = (editorStateScreeningMoreInfo) => {
        this.setState({
            editorStateScreeningMoreInfo,
        });
    };

    handleChangeGenre = selectedOptionGenre => {
        this.setState({
            genre: []
        })
        this.setState({
            genre: selectedOptionGenre
        });
    };

    handleChangenInterestTrack = interestTrack => {
        this.setState({
            interestTrack: []
        })
        this.setState({
            interestTrack: interestTrack
        })
    };

    handleChangenAccessibility = accessibility => {
        this.setState({
            accessibility: []
        })
        this.setState({
            accessibility: accessibility
        })
    };


    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    SelectPlayerDropChange =(e)=>{
        const { name, value } = e.target;
        console.log(name,"name,value", value);
        this.setState({
            [name]:  parseInt(1)})
    }

    dropChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: { value: value, label: name }
        }, () => {
            var newDateAndTime = [{
                _id: Math.random(),
                screeningType: { _id: '1', label: 'Premiere' },
                date: new Date(),
                hours: { value: '7', label: '7' },
                minutes: { value: '30', label: '30' },
                state: { value: 'AM', label: 'AM' }
            }]

            this.state.film.category.forEach((item) => {
                if (item._id === value) {
                    if (item.type === 2) {
                        this.setState({
                            shortFlim: true,
                            indiesFlim: false,
                            dropDownRemoveForIndiesSeries: false
                        }, () => {
                            this.apiserve.sendevent("fpg|shortProgramme|dropList|get", {});
                        })
                    }
                    if (item.type === 3) {
                        this.setState({
                            shortFlim: false,
                            indiesFlim: true,
                            dropDownRemoveForIndiesSeries: true,
                            dateTime: newDateAndTime
                        })
                    }
                    if (item.type === 1) {
                        this.setState({
                            indiesFlim: false,
                            shortFlim: false,
                            dropDownRemoveForIndiesSeries: false,
                            dateTime: newDateAndTime
                        })
                    }
                }
            })

        })
    }

    dropChangeShortProgram = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: { _id: value, label: name },
        }, () => {
            var dataShort = [];
            this.state.shortProgramme.map(item => {
                if (item._id === value) {
                    var shortProgramme = {
                        _id: item._id, name: item.name, date: item.date
                    }
                    dataShort.push(shortProgramme)
                }
            })

            this.setState({
                shortFlim: true,
                shortDateTime: dataShort
            })
        });
    }

    dropChangeCountryYear = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }



    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
        })
    }

    cancelFilmLit = () => {
        // this.props.dispatch({type: 'CurrentTab', res: 0})
        this.setState({
            discardPopup: true
        })
    }

    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }

    submitFilm = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({ loaderFlag: true, filmDisabled: true })

            let creditsData = this.state.credits.map(cl => {
                console.log(cl,"ccllll");
                let credits = {
                    creditId: cl && cl.creditId && cl.creditId.value,
                    identifier:cl && cl.identifier,
                    creditTypeValue: cl && cl.creditTypeValue,
                    creditType: [],
                }
                cl && cl.creditType.map(cli => {
                    var creditType = { creditsInsideType: cli.creditsInsideType }
                    credits && credits.creditType.push(creditType)
                })
                return credits
            });

            var genreData = this.state && this.state.genre.map(item => {
                var genre = item.value

                return genre
            })

            var interestTrack = this.state && this.state.interestTrack.map(item => {
                var interestTrack = item.value

                return interestTrack
            })

            var accessibilityData = this.state && this.state.accessibility.map(item => {
                var accessibility = item.value

                return accessibility
            })


            const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
            const markup = draftToHtml(name);

            const nameExplicitContent = this.state.editorStateExplicitContent ? convertToRaw(this.state.editorStateExplicitContent.getCurrentContent()) : ''
            const markupExplicitContent = draftToHtml(nameExplicitContent);

            const nameScreeningMoreInfo = this.state.editorStateScreeningMoreInfo ? convertToRaw(this.state.editorStateScreeningMoreInfo.getCurrentContent()) : ''
            const markupScreeningMoreInfo = draftToHtml(nameScreeningMoreInfo);


            if (this.state.filmId) {
                let updateCreateFilm = {
                    filmId: this.state.filmId,
                    fileMakerId: this.state.fileMakerId,
                    // shift72Id: this.state.shift72Id,
                    eventiveId: this.state.eventiveId,
                    playerType: this.state.playerType,
                    access: this.state.access && this.state.access.value,
                    title: this.state.title,
                    description: markup,
                    images: this.state.images,
                    credits: creditsData,
                    year: this.state.year,
                    category: this.state.category && this.state.category.value,
                    // isAudioDescription: this.state.isAudioDescription,
                    audioDescriptionShift72Id: this.state.audioDescriptionShift72Id,
                    audioDescriptionEventiveId: this.state.audioDescriptionEventiveId,
                    isExplicitContent: this.state.isExplicitContent,
                    explicitContent: markupExplicitContent,
                    screeningMoreInfoTitle: this.state.screeningMoreInfoTitle,
                    screeningMoreInfo: markupScreeningMoreInfo,
                    country: this.state.country,
                    runTime: this.state.runTime,
                    website: this.state.website,
                    genre: genreData,
                    interestTrack: interestTrack,
                    accessibility: accessibilityData,
                    contact: this.state.contact,
                    company: this.state.company,
                    // qaReplayLink: this.state.qaReplayLink,

                }
                this.apiserve.sendevent("privateScreeningPartner|film|edit", updateCreateFilm);
            } else {
                let addCreateFilm = {
                    fileMakerId: this.state.fileMakerId,
                    // shift72Id: this.state.shift72Id,
                    eventiveId: this.state.eventiveId,
                    playerType: this.state.playerType,
                    access: this.state.access && this.state.access.value,
                    title: this.state.title,
                    description: markup,
                    images: this.state.images,
                    credits: creditsData,
                    year: this.state.year,
                    category: this.state.category && this.state.category.value,
                    // isAudioDescription: this.state.isAudioDescription,
                    audioDescriptionShift72Id: this.state.audioDescriptionShift72Id,
                    audioDescriptionEventiveId: this.state.audioDescriptionEventiveId,
                    isExplicitContent: this.state.isExplicitContent,
                    explicitContent: markupExplicitContent,
                    screeningMoreInfoTitle: this.state.screeningMoreInfoTitle,
                    screeningMoreInfo: markupScreeningMoreInfo,
                    country: this.state.country,
                    runTime: this.state.runTime,
                    website: this.state.website,
                    genre: genreData,
                    interestTrack: interestTrack,
                    accessibility: accessibilityData,
                    contact: this.state.contact,
                    company: this.state.company,
                    // qaReplayLink: this.state.qaReplayLink,
                }
                console.log(addCreateFilm,"addCreateFilm");
                this.apiserve.sendevent("privateScreeningPartner|film|create", addCreateFilm);
            }

            this.state.images.forEach(image => {
                delete image._id
            });
        }
        else {
            this.setState({
                messageModal: true,
                filmDisabled: false,
            })
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    //Genre Master Call
    genreOption = () => {
        var options = []
        this.state.film && this.state.film.genre && this.state.film.genre.forEach(item => {
            options.push({ value: item._id, label: item.name })
        });
        return options
    }

    //Accessibility Master Call
    accessibilityOption = () => {
        var options = []
        this.state.film && this.state.film.accessibility && this.state.film.accessibility.forEach(item => {
            options.push({ value: item._id, label: item.name })
        });
        return options
    }

    //Interest Track Master Call
    interestTrackOption = () => {
        var options = []
        this.state.film && this.state.film.interestTrack && this.state.film.interestTrack.forEach(item => {
            options.push({ value: item._id, label: item.name })
        });
        return options
    }

    //Year Call
    getYears = () => {
        var years = ["Select From Below"];
        var startYear = 2023;
        // const year = new Date().getFullYear();
        const year = 2000;

        for (var start = startYear; start >= year; start--) {
            years.push(start.toString());
        }

        return years;
    };

    //Contact Push
    addContactFiled = (item) => {
        var newContact = {
            _id: Math.random(),
            emailPhone: ""
        }
        var oldContact = this.state.contact
        oldContact.push(newContact)
        this.setState({
            contact: oldContact
        });
    }

    //Contact Remove
    removeContactFiled = (i) => {
        var filteredContact = this.state.contact.filter(_ => _._id !== i)

        this.setState({
            contact: filteredContact
        });
    }

    onChangeContact = (e, id) => {
        const { name, value } = e.target;
        this.state.contact.forEach(contactList => {
            if (contactList._id === id)
                contactList[name] = value
        });
        this.setState({})
    };

    //Event Date And Time Push
    addDateAndTime = (item) => {
        var newDateAndTime = {
            _id: Math.random(),
            screeningType: item.screeningType,
            premierScreening: {
                waitingRoomTrailerShift72Id: "",
                isSponsor: false,
                sponsorLogo: ""
            },
            date: new Date(),
            hours: { value: '7', label: '7' },
            minutes: { value: '30', label: '30' },
            state: { value: 'AM', label: 'AM' }
        }
        var oldDateAndTime = this.state.dateTime
        oldDateAndTime.push(newDateAndTime)
        this.setState({
            dateTime: oldDateAndTime
        });
    }

    //Event Date And Time Remove
    removeDateAndTime = (i) => {
        var filteredscreening = this.state.dateTime.filter(_ => _._id !== i)

        this.setState({
            dateTime: filteredscreening
        });
    }

    //MeetArtists Push
    addMeetArtists = (item) => {
        var newMeetArtist = {
            _id: Math.random(),
            image: "",
            name: "",
            description: EditorState.createEmpty(),
            youtube: "",
            instagram: "",
            twitter: "",
        }
        var oldMeetArtist = this.state.artist
        oldMeetArtist.push(newMeetArtist)


        //   if(this.state.artist.length <= this.state.maxNumberOfRules){
        this.setState({
            artist: oldMeetArtist
        });
        //   }

    }

    //MeetArtists Remove
    removeMeetArtists = (i) => {
        var filterArtist = this.state.artist.filter(_ => _._id !== i)

        this.setState({
            artist: filterArtist
        });
    }

    handleImageAwardSponsorLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                this.uploadAwardSponsorLogo.value = ''

                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadAwardSponsorLogo(file,event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadAwardSponsorLogo = (file, img) => {
        this.setState({ ImagePreloaderAwardSponsorLogo: true })
        var fileSet= commonImage(file,false,'',img)
        fileSet.then((value) => {
            this.setState({
                awardSponsorLogo: value,
                ImagePreloaderAwardSponsorLogo: false
            })
        })
    }

    handleImageSponsorLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                this.uploadSponsorLogo.value = ''
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadSponsorLogo(file,event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadSponsorLogo = (file, img) => {
        this.setState({ ImagePreloaderSponsorLogo: true })
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                this.setState({
                    sponsorLogo: value,
                    ImagePreloaderSponsorLogo: false
                })
            })
    }

    handleImageSponsorLogoPre(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                this.uploadSponsorLogo.value = ''
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 100e6) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 200 MB'
                    })
                    return false;
                }
                if (file.type === "video/mp4") {
                    setTimeout(() => {
                        this.imageUploadSponsorLogoPre(file, id,event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 200 MB'
                    })
                }
            })
        }
    }

    imageUploadSponsorLogoPre = (file, id, img) => {

        this.setState({ ImagePreloaderSponsorLogoPre: true })
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                this.setState({
                    premiereScreeningData: this.state.dateTime[this.state.premiereScreeningIndex].waitingRoomTrailerShift72Id = value,
                    ImagePreloaderSponsorLogoPre: false
                })
            });
    }

    handleImageSponsorLogoList(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                this.uploadMeetList.value = "";

                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadSponsorLogoList(file, id,event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadSponsorLogoList = (file, id, img) => {
        this.setState({ ImagePreloaderSponsorLogoList: true })

        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
                this.setState({
                    premiereScreeningData: this.state.dateTime[this.state.premiereScreeningIndex].sponsorLogo = value,
                    ImagePreloaderSponsorLogoList: false
                })
            });
    };

    handleCheckIsSponsor = (e, id) => {
        const { name, checked } = e.target;
        this.setState({
            premiereScreeningData: this.state.dateTime[this.state.premiereScreeningIndex].isSponsor = checked,
            ImagePreloaderSponsorLogoList: false
        })
    }

    handleChnageWaitingRoom = (e, id) => {
        const { name, value } = e.target;
        this.setState({
            premiereScreeningData: this.state.dateTime[this.state.premiereScreeningIndex].waitingRoomTrailerShift72Id = value,
            ImagePreloaderSponsorLogoList: false
        })
    }

    handleCheck = (e) => {
        const { name, checked } = e.target;
        this.setState({
            [name]: checked
        })

    }
    onInputChangeMeet = (e, id) => {
        const { name, value } = e.target
        this.state.artist.forEach(element => {
            if (element._id === id) {
                element[name] = value
            }
        });
        this.setState({})
    }

    onEditorStateChangeDesc = (description, id) => {
        this.state.artist.forEach((dataList) => {
            if (dataList._id === id) {
                dataList.description = description;
            }
        });

        this.setState({});
    };

    handleChangeDate = (date, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.date = date
            }
        });
    }

    handleTimeHours = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.hours = e
            }
        });
    }

    handleTimeMin = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.minutes = e
            }
        });
    }

    handleTimeStamps = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.state = e
            }
        });
    }

    onChangeScreeningType = (e, parentId) => {
        const { name, value } = e.target;
        this.state.dateTime.forEach(screeening => {
            if (screeening._id === parentId) {
                screeening[name] = { value: value, label: name }
            }
        });

        this.setState({})
    };

    makeOption = (data) => {
        return (
            { value: data, label: data }
        )
    }

    //Credit Push
    addCredit = (item) => {
        var newCredit = {
            _id: Math.random(),
            creditId: item,
            creditType: [{
                _id: Math.random(),
                creditsInsideType: ''
            }]
        }
        var oldCredit = this.state.credits
        oldCredit.push(newCredit)
        this.setState({
            credits: oldCredit
        });
    }

    //Credit Remove
    removeCredit = (i) => {
        var filteredCredit = this.state.credits.filter(_ => _._id !== i)

        this.setState({
            credits: filteredCredit
        });
    }

    addInsideCredit = (item) => {
        var creditType = {
            _id: Math.random(),
            creditsInsideType: ''
        }

        this.state.credits.forEach(element => {
            if (element._id === item._id) {
                element.creditType.push(creditType)
            }
        });
        this.setState({})
    }

    removeInsideCredit = (parentId, childId) => {
        this.state.credits.forEach(element => {
            if (element._id === parentId) {
                var filterInsideCredit = element.creditType.filter(_ => _._id !== childId);
                element.creditType = filterInsideCredit
            }
        });
        this.setState({});
    }

    onChangeCredit = (e, parentId, childId) => {
        const { name, value } = e.target;
        let newCredit = this.state.credits
        this.state.credits.forEach(creditsList => {
            if (creditsList._id === parentId)
                creditsList.creditType.forEach(element => {
                    if (element._id === childId)
                        element[name] = value
                });
        });

        let creditValue = ''
        newCredit.map(credit => {
            let clength = credit.creditType.length
            credit.creditType.map((type, i) => {
                console.log(clength,"length",i+1);
                creditValue += type.creditsInsideType 
                if(clength !== i+1){ 
                    creditValue += ','
                }  
            })
            credit.creditTypeValue = creditValue
            creditValue = ''
        })

        this.setState({})
    };

    dropChangeCreditLabel = (e, id) => {
        const { name, value } = e.target;

        var identifier =''
        this.state.film && this.state.film.creditLabel.map(label => {
            if(label._id === value){
                // console.log("label",label, value);
                identifier = label.identifier
            }
        })
        // console.log(identifier,"identifier");
        this.state.credits.forEach(creditsList => {
            if (creditsList._id === id){
                creditsList[name] = { value: value, label: value }
                creditsList.identifier = identifier
            }
        });
        this.setState({})
    }

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.credits];
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                _id: Math.random(),
                creditId: '',
                creditType: [{
                    _id: Math.random(),
                    creditsInsideType: '',
                    sortIndex: i + 1,
                }]
            });
        });
        this.setState({ isDraggable: true });
        const data = { order: updateArr };
        this.setState({ credits: arr });
    };

    //Credit Lable Master Call
    creditLabel = () => {
        this.state.film && this.state.film.creditLabel.forEach(item => this.setState({ creditLabel: [...this.state.creditLabel, item.name] }));
    }

    deleteImagePopup = () => {
        if (this.state.sponsorLogoDetails) {
            this.setState({
                sponsorLogo: '',
            })
        }
        if (this.state.awardSponsorLogoDetails) {
            this.setState({
                awardSponsorLogo: ''
            })
        }
        if (this.state.images.length) {
            this.state.images.forEach(image => {
                if (image._id === this.state.deleteImageId) {
                    image.inSite = ''
                }
            });
        }
        if (this.state.artist.length) {
            this.state.artist.forEach(element => {
                if (element._id === this.state.deleteImageId) {
                    element.image = ''
                }
            });
        }

        if (this.state.dateTime.length) {
            if (this.state.dateTime[this.state.premiereScreeningIndex] && this.state.dateTime[this.state.premiereScreeningIndex].waitingRoomTrailerShift72Id) {
                this.setState({
                    premiereScreeningData: this.state.dateTime[this.state.premiereScreeningIndex].waitingRoomTrailerShift72Id = ''
                })
            }
            if (this.state.dateTime[this.state.premiereScreeningIndex] && this.state.dateTime[this.state.premiereScreeningIndex].sponsorLogo) {
                this.setState({
                    premiereScreeningData: this.state.dateTime[this.state.premiereScreeningIndex].sponsorLogo = ''
                })
            }
        }


        this.setState({
            deleteImagePopup: false,
            sponsorLogoDetails: false,
            awardSponsorLogoDetails: false,
            deleteImageId: '',

        })
    }

    onDeleteImagePopup = () => {
        var self=this;
        this.state.images.forEach(image => {
          if (image._id === self.state.deleteId) {
            image.inSite = "";
          }
        });
        this.setState({
          deleteImagePopup: false
        });
        this.forceUpdate();
      };

    setDeleteImagePopup = (e,id) => {
        this.setState({
            deleteImagePopup: true,
            deleteId: id
        })
    }

    deleteImage(id) {
        this.setState({
            deleteImagePopup: true,
            deleteImageId: id
        })
    }

    deleteImageSponsor() {
        this.setState({
            deleteImagePopup: true,
            awardSponsorLogoDetails: false,
            sponsorLogoDetails: true,
        })
    }

    deleteImageAwardSponsorLogo() {
        this.setState({
            deleteImagePopup: true,
            awardSponsorLogoDetails: true,
            sponsorLogoDetails: false
        })
    }

    insideOnchange = (e, id) => {
        const { name, value } = e.target
        this.state.images.forEach(inside => {
            if (inside._id === id) {
                inside.link = value
            }
        });
        this.forceUpdate()
    }

    errorPopup = () => {
        this.setState({
            errorPopup: false,
            errorMsg: ''
        })
    }

    ScreenToggle = (e) => {
        var active = e.target.parentNode.closest(".inner_screen").querySelector(".screen_header").classList.toggle("active");
        var parentactive = e.target.closest(".screen_header").parentNode.parentNode.classList.toggle("active");
        var panel = e.target.parentNode.closest(".inner_screen").querySelector(".screen_content_outer");
        if (panel && panel.style.maxHeight) {
            panel.style.maxHeight = "";
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
        this.setState({
            screencontent: !this.state.screencontent
        })
    }

    previewRecord = (e) => {
        e.preventDefault()
        let updateCreateFilm = {}
        if (this.state.filmId) {
            let creditsData = this.state.credits.map(creditsList => {
                var temp = this.state.film.creditLabel.find(_ => _._id === creditsList.creditId.value)
                var credits = {
                    creditId: temp && temp.name ? temp.name : '',
                    creditType: []
                }
                creditsList && creditsList.creditType.map(creditListItem => {
                    var creditType = {
                        creditsInsideType: creditListItem.creditsInsideType
                    }
                    credits && credits.creditType.push(creditType)
                })
                return credits
            });

            var genreData = this.state && this.state.genre.map(item => {
                var genre = item.label

                return genre
            })

            var interestTrack = this.state && this.state.interestTrack.map(item => {
                var interestTrack = item.value

                return interestTrack
            })

            var accessibilityData = this.state && this.state.accessibility.map(item => {
                var accessibility = item.value

                return accessibility
            })



            var dateTimeDate = this.state && this.state.dateTime.map(item => {
                var countDownDateFinal = new Date(item.date);
                countDownDateFinal.setHours(item.state.value === 'PM' || item.state.value === 'pm' ? parseInt(item.hours.value) === 12 ? parseInt(item.hours.value) : parseInt(item.hours.value) + 12 : parseInt(item.hours.value) === 12 ? parseInt(item.hours.value) - 12 : parseInt(item.hours.value), item.minutes.value);
                var dateTime = {
                    screeningType: item && item.screeningType && item.screeningType._id || item && item.screeningType && item.screeningType.value,
                    premierScreening: this.state.premiereScreeningData,
                    date: countDownDateFinal,
                    hours: item.hours.value,
                    minutes: item.minutes.value,
                    state: item.state.value
                }
                return dateTime
            })
            var displayNameData = this.state.film.category.find(_ => _._id === this.state.category.value || undefined)
            var displayName = displayNameData && displayNameData.displayName ? displayNameData.displayName : ''
            const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
            const markupShort = draftToHtml(name);

            const nameShort = this.state.editorStateShort ? convertToRaw(this.state.editorStateShort.getCurrentContent()) : ''
            const markup = draftToHtml(nameShort);
            var artist = this.state.artist.map((element) => {
                const name =
                    element && element.description
                        ? convertToRaw(element && element.description.getCurrentContent())
                        : "";
                const markup = draftToHtml(name);

                var List = {
                    image: element.image,
                    name: element.name,
                    description: markup.trim(),
                    youtube: element.youtube,
                    instagram: element.instagram,
                    twitter: element.twitter,

                };

                return List;
            });
            updateCreateFilm = {
                filmId: this.state.filmId,
                fileMakerId: this.state.fileMakerId,
                // shift72Id: this.state.shift72Id,
                access: this.state.access && this.state.access.label,
                title: this.state.title,
                description: markup,
                shortDescription: markupShort,
                images: this.state.images,
                credits: creditsData,
                year: this.state.year,
                category: displayName,
                country: this.state.country,
                runTime: this.state.runTime,
                website: this.state.website,
                contact: this.state.contact,
                company: this.state.company,
                genre: genreData,
                interestTrack: interestTrack,
                accessibility: accessibilityData,
                dateTime: this.state.shortFlim === true ? [] : dateTimeDate,
                // shortProgrammeId: this.state.shortProgramme1._id,
                // qaReplayLink: this.state.qaReplayLink,
                teamConnection: [
                    {
                        name: this.state.fullNameFirst,
                        email: this.state.fullEmailFirst
                    },
                    {
                        name: this.state.fullNameSecond,
                        email: this.state.fullEmailSecond
                    }],
                artist: artist

            }
            let previewRecordFilm = this.apiserve.encrypt(updateCreateFilm)
            window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FPG + 'film-preview?data=' + previewRecordFilm);
        }
    }

    closeAdminUser = () => {
        this.setState({
            discardPopup: false,
            deleteImagePopup: false
        });
    };

    discardPopupYes = () => {
        if(this.state.filmId){
            this.props.history.push('/partner-film-detail-view/' + this.state.filmId, { filmLength: this.props.location && this.props.location.state && this.props.location.state.filmLength || 0 })
        }else{
            this.props.history.push('/partners-film-view')
            // this.setState({
            //     artist:[],  
            //     shortDateTime:[],
            //     previewRecordFilm:[],
            //     shortProgramme1: '',
            //     shortProgramme: '',
            //     shortProgrammeDrop: '',
            //     fileMakerId: "",
            //     shift72Id: "",
            //     access: "",
            //     title: "",
            //     description: EditorState.createEmpty(),
            //     editorState: EditorState.createEmpty(),
            //     shortDescription: EditorState.createEmpty(),
            //     editorStateScreeningMoreInfo: EditorState.createEmpty(),
            //     credits: [{
            //         _id: Math.random(),
            //         creditId: '',
            //         creditType: [{
            //             _id: Math.random(),
            //             creditsInsideType: ''
            //         }]
            //     }],
            //     year: "",
            //     awardCategory: "",
            //     awardSponsorLogo: "",
            //     votes: "",
            //     audioDescriptionShift72Id: "",
            //     explicitContent: EditorState.createEmpty(),
            //     sponsorLogo: "",
            //     screeningMoreInfoTitle: "",
            //     screeningMoreInfo: EditorState.createEmpty(),
            //     editorStateExplicitContent: EditorState.createEmpty(),
            //     country: "",
            //     runTime: '',
            //     company:'',
            //     website: "",
            //     contact: [
            //         {
            //             _id: Math.random(),
            //             emailPhone: '',
            //         }
            //     ],
            //     genre: [],
            //     interestTrack: [],
            //     accessibility: [],
            //     dateTime: [
            //         {
            //             _id: Math.random(),
            //             screeningType: { _id: '1', name: 'Premiere' },
            //             date: new Date(),
            //             hours: { value: '7', label: '7' },
            //             minutes: { value: '30', label: '30' },
            //             state: { value: 'AM', label: 'AM' },
            //             premierScreening: {
            //                 waitingRoomTrailerShift72Id: "",
            //                 isSponsor: false,
            //                 sponsorLogo: ""
            //             }
            //         }
            //     ],
            //     qaReplayLink: "",
            //     teamConnection: [{
            //         name: "",
            //         email: ""
            //     }],
            //     artist: [{
            //         _id: Math.random(),
            //         image: "",
            //         name: "",
            //         description: EditorState.createEmpty(),
            //         youtube: "",
            //         instagram: "",
            //         twitter: "",
            //     }],
            //     creditLabel: [],
                
            //     images: [
            //         {
            //             _id: Math.random(),
            //             link: "",
            //             inSite: ""
            //         },
            //         {
            //             _id: Math.random(),
            //             link: "",
            //             inSite: ""
            //         },
            //         {
            //             _id: Math.random(),
            //             link: "",
            //             inSite: ""
            //         }
            //     ]
            // })
            // this.closeAdminUser();
            // this.apiserve.sendevent("user|sff|getAllInitialForRedis", {});
        }
    };

    HideScreeningModal = () => {
        this.setState({
            screeninfpopup: false
        })
    }

    OpenScreening = (item, index) => {
        this.setState({
            premiereScreeningData: item,
            premiereScreeningIndex: index
        }, () => {
            this.setState({
                screeninfpopup: true
            })
        })
    }

    premierePopUpScreening = () => {
        const screeningData = this.state.dateTime
        let screeningList = {
            waitingRoomTrailerShift72Id: screeningData[this.state.premiereScreeningIndex].waitingRoomTrailerShift72Id,
            isSponsor: screeningData[this.state.premiereScreeningIndex].isSponsor,
            sponsorLogo: screeningData[this.state.premiereScreeningIndex].sponsorLogo
        }

        this.setState({
            premiereScreeningData: screeningList,
            screeninfpopup: false
        })
    }

    videoUpload = (file, id, img) => {
        this.setState({ videoPreLoader: true });
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
            const { images: images } = this.state;

            images.forEach(image => {
                if (image._id === id) {
                    image.inSite = value;
                    // image.link = data && data.Location;
                }
            });
            this.setState({ videoPreLoader: false, [`imagePreloader_${id}`]: false, images });
        });
    };

    imageUpload = (file, id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state, imagePreloader: true };
        newState[imagePreloaderId] = true;
        this.setState(newState);
        var fileSet= commonImage(file,false,'',img)
         fileSet.then((value) => {
            this.state.images.forEach(image => {
                const imagePreloaderId = `imagePreloader_${id}`;
                const newState = { ...this.state };
                newState[imagePreloaderId] = false;
                this.setState(newState);
                if (image._id === id) {
                    image.inSite = value;
                }
            });
            this.setState({ imagePreloader: false });
        });
    };

    uploadVideoImage = (file, id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state, videoPreLoader: true };
        newState[imagePreloaderId] = true;
        this.setState(newState);
        debugger
        var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
          this.state.images.forEach(image => {
            const imagePreloaderId = `imagePreloader_${id}`;
            const newState = { ...this.state };
            newState[imagePreloaderId] = false;
            this.setState(newState);
    
            if (image._id === id) {
              image.inSite = value;
            }
          });
          this.forceUpdate();
        });
      };

    onChangeFile = (e, id) => {
        e.stopPropagation();
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);    
        reader.onloadend = (event) => {
          this.setState({
            file: file
            // base64: reader.result
          });
          if (
            (file && file.type === "image/png") ||
            (file && file.type === "image/jpg") ||
            (file && file.type === "image/jpeg")
          ) {
            const fileList = Math.round(file && file.size / 1024);
            if (fileList >= 2048) {
              this.setState({
                errorPopup: true,
                errorMsg: "Please upload a file smaller than 2 MB"
              });
              return false;
            }
            if (file && (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg")) {
              this.setState({ isImage: true });
    
              setTimeout(() => {
                this.uploadVideoImage(file, id,event.target.result);
              }, 0);
            } else {
              this.setState({
                errorPopup: true,
                errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB"
              });
            }
          } else {
            if (file.size > 100e6) {
              this.setState({
                errorPopup: true,
                errorMsg: "Please upload a video smaller than 100 MB"
              });
              return false;
            }
    
            if (file.type === "video/mp4") {
              setTimeout(() => {
                this.uploadVideoImage(file, id,event.target.result);
              }, 0);
              return false;
            } else {
              this.setState({
                errorPopup: true,
                errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB"
              });
            }
          }
        };
      };

      insideFilechange = (e, id) => {
        const { name, value } = e.target;
        this.state.images.forEach(image => {
          if (image._id === id) {
            image.link = value;
          }
        });
        this.setState({isImage:true})
        this.forceUpdate();
      };

    render() {
        const { countryType, contact, dateTime, credits, indiesFlim } = this.state
        const year = this.getYears();
        var settings = {
            customPaging: function (i) {
                return (
                    <a>{i + 1}</a>
                );
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        var sponsersettings = {
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };


        const hours = [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]

        const minutes = [
            { value: '00', label: '00' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]

        const state = [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]
        const self = this;
        const { profileName } = this.props
        return (
            <>
                <div className="right_side_wrapper adminDashboard_wrapper">
                    <div className="dashboard_header with_btn profile_header">
                        <div className="searchBlock p_0">
                            <span className="d_flex d_flex_align_center"> <Link to='/partners-profile' ><span>
                                {profileName && profileName.fname ? profileName.fname + ' ' + profileName.lname : ''}</span> </Link>&nbsp;&nbsp;
                                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.75 1.75C2.75 1.94778 2.69135 2.14112 2.58147 2.30557C2.47159 2.47002 2.31541 2.59819 2.13268 2.67388C1.94996 2.74957 1.74889 2.76937 1.55491 2.73079C1.36093 2.6922 1.18275 2.59696 1.04289 2.45711C0.903041 2.31725 0.8078 2.13907 0.769215 1.94509C0.73063 1.75111 0.750433 1.55004 0.826121 1.36732C0.901809 1.18459 1.02998 1.02841 1.19443 0.918531C1.35888 0.80865 1.55222 0.750001 1.75 0.750001C2.01522 0.750001 2.26957 0.855357 2.45711 1.04289C2.64464 1.23043 2.75 1.48478 2.75 1.75ZM6 0.750001C5.80222 0.750001 5.60888 0.80865 5.44443 0.918531C5.27998 1.02841 5.15181 1.18459 5.07612 1.36732C5.00043 1.55004 4.98063 1.75111 5.01922 1.94509C5.0578 2.13907 5.15304 2.31725 5.29289 2.45711C5.43275 2.59696 5.61093 2.6922 5.80491 2.73079C5.99889 2.76937 6.19996 2.74957 6.38268 2.67388C6.56541 2.59819 6.72159 2.47002 6.83147 2.30557C6.94135 2.14112 7 1.94778 7 1.75C7 1.48478 6.89464 1.23043 6.70711 1.04289C6.51957 0.855357 6.26522 0.750001 6 0.750001ZM10.25 2.75C10.4478 2.75 10.6411 2.69135 10.8056 2.58147C10.97 2.47159 11.0982 2.31541 11.1739 2.13268C11.2496 1.94996 11.2694 1.74889 11.2308 1.55491C11.1922 1.36093 11.097 1.18275 10.9571 1.04289C10.8173 0.903041 10.6391 0.8078 10.4451 0.769215C10.2511 0.73063 10.05 0.750433 9.86732 0.826121C9.68459 0.901809 9.52841 1.02998 9.41853 1.19443C9.30865 1.35888 9.25 1.55222 9.25 1.75C9.25 2.01522 9.35536 2.26957 9.54289 2.45711C9.73043 2.64464 9.98478 2.75 10.25 2.75ZM1.75 5C1.55222 5 1.35888 5.05865 1.19443 5.16853C1.02998 5.27841 0.901809 5.43459 0.826121 5.61732C0.750433 5.80004 0.73063 6.00111 0.769215 6.19509C0.8078 6.38907 0.903041 6.56725 1.04289 6.70711C1.18275 6.84696 1.36093 6.9422 1.55491 6.98079C1.74889 7.01937 1.94996 6.99957 2.13268 6.92388C2.31541 6.84819 2.47159 6.72002 2.58147 6.55557C2.69135 6.39112 2.75 6.19778 2.75 6C2.75 5.73478 2.64464 5.48043 2.45711 5.29289C2.26957 5.10536 2.01522 5 1.75 5ZM6 5C5.80222 5 5.60888 5.05865 5.44443 5.16853C5.27998 5.27841 5.15181 5.43459 5.07612 5.61732C5.00043 5.80004 4.98063 6.00111 5.01922 6.19509C5.0578 6.38907 5.15304 6.56725 5.29289 6.70711C5.43275 6.84696 5.61093 6.9422 5.80491 6.98079C5.99889 7.01937 6.19996 6.99957 6.38268 6.92388C6.56541 6.84819 6.72159 6.72002 6.83147 6.55557C6.94135 6.39112 7 6.19778 7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5ZM10.25 5C10.0522 5 9.85888 5.05865 9.69443 5.16853C9.52998 5.27841 9.40181 5.43459 9.32612 5.61732C9.25043 5.80004 9.23063 6.00111 9.26922 6.19509C9.3078 6.38907 9.40304 6.56725 9.54289 6.70711C9.68275 6.84696 9.86093 6.9422 10.0549 6.98079C10.2489 7.01937 10.45 6.99957 10.6327 6.92388C10.8154 6.84819 10.9716 6.72002 11.0815 6.55557C11.1914 6.39112 11.25 6.19778 11.25 6C11.25 5.73478 11.1446 5.48043 10.9571 5.29289C10.7696 5.10536 10.5152 5 10.25 5ZM1.75 9.25C1.55222 9.25 1.35888 9.30865 1.19443 9.41853C1.02998 9.52841 0.901809 9.68459 0.826121 9.86732C0.750433 10.05 0.73063 10.2511 0.769215 10.4451C0.8078 10.6391 0.903041 10.8173 1.04289 10.9571C1.18275 11.097 1.36093 11.1922 1.55491 11.2308C1.74889 11.2694 1.94996 11.2496 2.13268 11.1739C2.31541 11.0982 2.47159 10.97 2.58147 10.8056C2.69135 10.6411 2.75 10.4478 2.75 10.25C2.75 9.98478 2.64464 9.73043 2.45711 9.54289C2.26957 9.35536 2.01522 9.25 1.75 9.25ZM6 9.25C5.80222 9.25 5.60888 9.30865 5.44443 9.41853C5.27998 9.52841 5.15181 9.68459 5.07612 9.86732C5.00043 10.05 4.98063 10.2511 5.01922 10.4451C5.0578 10.6391 5.15304 10.8173 5.29289 10.9571C5.43275 11.097 5.61093 11.1922 5.80491 11.2308C5.99889 11.2694 6.19996 11.2496 6.38268 11.1739C6.56541 11.0982 6.72159 10.97 6.83147 10.8056C6.94135 10.6411 7 10.4478 7 10.25C7 9.98478 6.89464 9.73043 6.70711 9.54289C6.51957 9.35536 6.26522 9.25 6 9.25ZM10.25 9.25C10.0522 9.25 9.85888 9.30865 9.69443 9.41853C9.52998 9.52841 9.40181 9.68459 9.32612 9.86732C9.25043 10.05 9.23063 10.2511 9.26922 10.4451C9.3078 10.6391 9.40304 10.8173 9.54289 10.9571C9.68275 11.097 9.86093 11.1922 10.0549 11.2308C10.2489 11.2694 10.45 11.2496 10.6327 11.1739C10.8154 11.0982 10.9716 10.97 11.0815 10.8056C11.1914 10.6411 11.25 10.4478 11.25 10.25C11.25 9.98478 11.1446 9.73043 10.9571 9.54289C10.7696 9.35536 10.5152 9.25 10.25 9.25Z" fill="white" />
                                </svg> &nbsp;&nbsp;{
                                    
                                    this.state.filmId ? <>  <p className='ml_5'>
                                        <Link to='/partner-screening-list'>
                                            <span>Films {`Films (${localStorage.getItem('filmListlength') || 0})`}</span>
                                        </Link></p> <p className='ml_5'>&nbsp; &gt;  &nbsp;&nbsp;</p>
                                        <p className='ml_5'>{this.state.title}</p></> : 
                                        <>
                                        <Link to='/partner-screening-list'>
                                        <span>{`Films (${localStorage.getItem('filmListlength') || 0})`}</span>
                                        </Link> <p className='ml_5'> &nbsp; &gt;  &nbsp;&nbsp;
                                        Add Film</p>
                                        </>
                                }
                            </span>
                        </div> 
                    </div>



                    <div className="fpg_tabcontent pl_15 fpg_create_film">
                        <form>
                            <div className="d_flex d_flex_align_baseline">
                                <div className="tab_col create_left_col">
                                    <div className="left_col">
                                        <div className="d_flex id_media d_flex_align_center">
                                            {this.state.filmId &&
                                                <span className="id_text d_flex d_flex_align_baseline"><label>Media ID: </label> {this.state.mediaId} </span>
                                            }
                                            {/* <span className="id_text d_flex d_flex_align_baseline"><label>Filemaker ID:</label>
                                                <div className="field_row mb_0">
                                                    <TextField
                                                        type="text"
                                                        name="fileMakerId" id="fileMakerId"
                                                        value={this.state.fileMakerId}
                                                        onChange={this.onInputChange}
                                                    />
                                                </div>
                                                <span style={{ color: 'red' }}>{this.validator.message('fileMakerId', this.state.fileMakerId, 'alpha_num')}</span>
                                            </span> */}
                                           
                                            {/* <span className="id_text d_flex d_flex_align_baseline"><label>Eventive ID:</label>
                                                <div className="field_row mb_0">
                                                    <TextField
                                                        type="text"
                                                        name="eventiveId" id="eventiveId"
                                                    />
                                                </div>
                                                <span style={{ color: 'red' }}>{this.validator.message('shift72Id', this.state.shift72Id, 'alpha_num')}</span>
                                            </span> */}
                                            {/* <span className="id_text d_flex d_flex_align_baseline"><label>Shift72 ID:</label>
                                                <div className="field_row mb_0">
                                                    <TextField
                                                        type="text"
                                                        name="shift72Id" id="shift72Id"
                                                        value={this.state.shift72Id}
                                                        onChange={this.onInputChange}
                                                    />
                                                </div>
                                                
                                               
                                            </span> */}
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <TextField label="Eventive ID: "
                                                name="eventiveId" id="eventiveId"
                                                value={this.state.eventiveId}
                                                    // onChange={this.onInputChange}
                                            //  fpgerror={this.validator.message('company', this.state.company, 'companyName')}
                                                disable={true}
                                            />
                                        </div>
                                            {/* <span style={{ color: 'red' }}>{this.validator.message(`${this.state.playerType === 1 ? 'shift72Id':'eventiveId'}`,this.state.playerType === 1 ?  this.state.shift72Id : this.state.eventiveId , this.state.playerType === 1 ? 'required|numeric' : 'required')}</span> */}
                                            {/* {this.state.playerType === 2 ?  */}
                                            {/* <span style={{ color: 'red' }}>{this.validator.message('eventiveId', this.state.eventiveId, 'required')}</span> */}
                                        <Slider {...settings}>
                                            {self.state.images &&
                                                self.state.images.map((item, i) => {
                                                    const imagePreloaderState = `imagePreloader_${item._id}`
                                                    return self.state.isImage ||
                                                    item.inSite.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null ||
                                                    item.link.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null ? (
                                                    <div className=" file_upload_400 relative">
                                                        <div className="uploads_files">
                                                            <VideoImageFile
                                                                item={item._id}
                                                                handleImage={e => self.onChangeFile(e, item._id)}
                                                                iconDelete={true}
                                                                size="2"
                                                                id={item._id}
                                                                image={item.link}
                                                                showDeleteIcon={item.inSite}
                                                                value={
                                                                item.inSite
                                                                    ? self.apiserve.imageUrl + item.inSite
                                                                    : item.link
                                                                }
                                                                insideOnchange={e => self.insideFilechange(e, item._id)}
                                                                videoPreLoader={self.state[imagePreloaderState]}
                                                                deleteImage={e => self.setDeleteImagePopup(e, item._id)}
                                                                isboth={true}
                                                            />
                                                        </div>
                                                        {i === 0 ?
                                                            <span style={{ color: 'red' }}>{this.validator.message('image or link', item.link || item.inSite, 'required|urlValidation')}</span>
                                                            : ''}
                                                    </div>
                                                    ) : (
                                                    <div className="file_upload_400 relative">
                                                        <div className="uploads_files">
                                                        <VideoOnlyUpload
                                                            handleVideo={e => self.onChangeFile(e, item._id)}
                                                            url={
                                                            item.inSite
                                                                ? `${self.apiserve.imageUrl}${item.inSite}`
                                                                : item.link
                                                            }
                                                            video={
                                                            item.inSite
                                                                ? `${self.apiserve.imageUrl}${item.inSite}`
                                                                : item.link
                                                            }
                                                            videoUrl={item.link}
                                                            insideOnchange={e => self.insideFilechange(e, item._id)}
                                                            item={item}
                                                            iconDelete={true}
                                                            showDeleteIcon={item.inSite}
                                                            videoPreLoader={self.state[imagePreloaderState]}
                                                            // setErrorMsg={setErrorMsg} setErrorPopup={setErrorPopup}
                                                            deleteVideo={e => self.setDeleteImagePopup(e, item._id)}
                                                            uploadmessage="Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB"
                                                        />
                                                        </div>
                                                        {i === 0 ?
                                                        <span style={{ color: 'red' }}>{this.validator.message('image or link', item.link || item.inSite, 'required|urlValidation')}</span>
                                                        : ''}
                                                    </div>
                                                    );
                                                    
                                                    
                                                })
                                            }
                                        </Slider> 
                                        {/* <Slider {...settings} >

                                            {this.state.images &&
                                                this.state.images.map((item, index) => {
                                                    const imagePreloaderState = `imagePreloader_${item._id}`
                                                    return (
                                                        <div>
                                                            {EXT_IMAGES.test(item.inSite) ? (
                                                                <React.Fragment>
                                                                    <div className="media_image mb_0 absolute_loader relative">
                                                                        {self.state.imagePreloader || self.state.videoPreLoader ? <Loader /> : ""}
                                                                        <img
                                                                            src={
                                                                                item.inSite.includes('http')
                                                                                    ? item.inSite
                                                                                    : self.apiserve.imageUrl + item.inSite
                                                                            }
                                                                            alt="image"
                                                                        />
                                                                        <span className="upload_message">
                                                                            Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB
                                                                       </span>
                                                                        <UploadForm
                                                                            item={item}
                                                                            handleImage={e => self.onChangeFile(e, item._id)}
                                                                            isboth={true}
                                                                            deleteImage={() => this.setDeleteImagePopup(item._id)}
                                                                        />
                                                                        {item.inSite ? <span className="remove_file pointer "
                                                                            onClick={() => this.setDeleteImagePopup(item._id)}
                                                                        ><DeletefileIcon /></span> :
                                                                            item.link ? '' : ''

                                                                        }
                                                                    </div>
                                                                </React.Fragment>
                                                            )
                                                                :
                                                                EXT_VIDEO.test(item.inSite || item.link) ? (
                                                                    <React.Fragment>
                                                                        <div className="form_group common_video_upload">
                                                                            <div className="form_group_inner">
                                                                                <label className="font_500 mb_5">Header Video</label>
                                                                                <div className="form_group_video loader-main">
                                                                                    <span className="form_note">
                                                                                        Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB
                                                                                  </span>
                                                                                    <div className="form_group_video_wpr">
                                                                                        {self.state.videoPreLoader || self.state.imagePreloader ? (
                                                                                            <Loader />
                                                                                        ) : (
                                                                                                <>
                                                                                                    <Player
                                                                                                        playsInline
                                                                                                        autoPlay={false}
                                                                                                        type="video/mp4"
                                                                                                        // src={this.apiserve.imageUrl +  this.state.homeVideo}
                                                                                                        src={item.inSite ? self.apiserve.imageUrl + item.inSite : item.link ? item.link : '/images/image-placeholder.png'}
                                                                                                    >
                                                                                                        <ControlBar autoHide={false} disableDefaultControls={true}>
                                                                                                            <PlayToggle />
                                                                                                        </ControlBar>
                                                                                                    </Player>
                                                                                                </>
                                                                                            )}
                                                                                    </div>
                                                                                    <span className={item.inSite ? "input_file active" : "input_file"}>
                                                                                        <input
                                                                                            name="homeVideo"
                                                                                            id="myInput"
                                                                                            type="file"
                                                                                            ref={ref => (self.videoUp = ref)}
                                                                                            onChange={e => self.onChangeFile(e, item._id)}
                                                                                            className="file-upload"
                                                                                            accept=".png, .jpg, .jpeg, .mp4"
                                                                                        />
                                                                                        <PlusIcon
                                                                                            className="video_add_icon"
                                                                                            onClick={() => {
                                                                                                self.videoUp.click();
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                    {item.inSite ? <span className="remove_file pointer "
                                                                                        onClick={() => this.setDeleteImagePopup(item._id)}
                                                                                    ><DeletefileIcon /></span> :
                                                                                        item.link ? '' : ''

                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </React.Fragment>
                                                                ) : <div className="media_image mb_0 absolute_loader relative">
                                                                        {self.state.imagePreloader || self.state.videoPreLoader ? <Loader /> : ""}
                                                                        <img
                                                                            src="/images/image-placeholder.png"
                                                                            alt="image"
                                                                        />
                                                                        <span className="upload_message">
                                                                            Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB
                                                </span>
                                                                        <UploadForm
                                                                            item={item}
                                                                            handleImage={e => self.onChangeFile(e, item._id)}
                                                                            isboth={true}
                                                                            deleteImage={() => this.setDeleteImagePopup(item._id)}
                                                                        />
                                                                    </div>}

                                                            <div className="field_row">
                                                                <div className="field_input relative">
                                                                    <input
                                                                        type="text"
                                                                        placeholder="https://cloudfront.aws.com/sdf2345"
                                                                        name="link"
                                                                        value={item.link}
                                                                        onChange={e => this.onPasteLink(e, item._id)}
                                                                        id={item._id}
                                                                    />
                                                                    <span className="copy_box">
                                                                        <CopyIcon />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                        </Slider> */}

                                        <div className="relative  static_pagination">

                                        </div>
                                    </div>


                                    <div className="credit_section">
                                        <div className="credit_header">
                                            <h5>Credits</h5>
                                        </div>
                                        <div className="create_credit_content">

                                            <DragDropContext onDragEnd={this.onDragEnd}>
                                                <Droppable droppableId="droppable">
                                                    {(provided, snapshot) => (
                                                        <ul {...provided.droppableProps} ref={provided.innerRef} >
                                                            {credits.map((item, index) => {
                                                                return (
                                                                    <Draggable
                                                                        key={item._id}
                                                                        draggableId={`'${item._id}'`}
                                                                        index={index}
                                                                    >
                                                                        {(provided, snapshot) => (
                                                                            <li className="d_flex d_flex_align_center d_flex_align_start"
                                                                                ref={provided.innerRef}
                                                                                {...provided.draggableProps}
                                                                                {...provided.dragHandleProps}>
                                                                                <span className="pointer d_flex dragger">
                                                                                    <DraggerIcon />
                                                                                </span>
                                                                                <div className="dopdown_add_remove d_flex d_flex_align_center">
                                                                                    <p className="action_wrap d_flex d_flex_align_center action_wrap d_flex_justify_end">
                                                                                        {index === 0 ?
                                                                                            <span className="pointer" onClick={() => this.addCredit(item)}>
                                                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                            </span>
                                                                                            :
                                                                                            <>
                                                                                                <span className="pointer" onClick={() => this.removeCredit(item._id)}>
                                                                                                    <FpgMinusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                                </span>
                                                                                                <span className="pointer" onClick={() => this.addCredit(item)}>
                                                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                                </span>
                                                                                            </>
                                                                                        }
                                                                                    </p>
                                                                                    <div className="field_row mb_0">
                                                                                        {this.state.filmId ?
                                                                                            <DropdownMaster
                                                                                                name="creditId"
                                                                                                options={
                                                                                                    this.state.film && this.state.film.creditLabel
                                                                                                }
                                                                                                onChange={(e) => this.dropChangeCreditLabel(e, item._id)}
                                                                                                value={item && item.creditId && item.creditId.value}
                                                                                                fpgerror={this.validator.message('creditLabel', item.creditId, 'required')}
                                                                                            />
                                                                                            :
                                                                                            <DropdownMaster
                                                                                                name="creditId"
                                                                                                options={
                                                                                                    this.state.film && this.state.film.creditLabel
                                                                                                }
                                                                                                onChange={(e) => this.dropChangeCreditLabel(e, item._id)}
                                                                                                fpgerror={this.validator.message('creditLabel', item.creditId, 'required')}
                                                                                            />
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    {item && item.creditType.map((insideCredit, indsideIndex) => (

                                                                                        <div className="textfield_add_remove d_flex d_flex_align_center">

                                                                                            <div className="field_row mb_0">
                                                                                                <TextField
                                                                                                    type="text"
                                                                                                    name="creditsInsideType" id="creditsInsideType"
                                                                                                    value={insideCredit.creditsInsideType}
                                                                                                    onChange={(e) => this.onChangeCredit(e, item._id, insideCredit._id)}
                                                                                                    fpgerror={this.validator.message('creditsInsideType', insideCredit.creditsInsideType, 'required')}
                                                                                                />
                                                                                            </div>
                                                                                            <p className="action_wrap aaaa d_flex d_flex_align_center action_wrap ">
                                                                                                {indsideIndex === 0 ?
                                                                                                    <span className="pointer" onClick={() => this.addInsideCredit(item)}>
                                                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                    </span>
                                                                                                    :
                                                                                                    <>
                                                                                                        <span className="pointer" onClick={() => this.removeInsideCredit(item._id, insideCredit._id)}>
                                                                                                            <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                        </span>
                                                                                                        <span className="pointer" onClick={() => this.addInsideCredit(item)}>
                                                                                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                        </span>
                                                                                                    </>
                                                                                                }
                                                                                            </p>


                                                                                        </div>

                                                                                    ))}
                                                                                </div>
                                                                            </li>
                                                                        )}
                                                                    </Draggable>
                                                                )
                                                            })}
                                                        </ul>
                                                    )}
                                                </Droppable>
                                            </DragDropContext>
                                        </div>
                                    </div>

                                </div>
                                <div className="tab_col create_feature_col d_flex">
                                    <div className="d_flex w_100">
                                        <div className="feature_top mt_25">
                                            <div className="fpg_edits_links d_flex d_flex_align_center">
                                            </div>
                                            <p className="feature_text">
                                            {/* <div className="field_row horizontal_field">
                                                    <DropdownMaster
                                                        label="Select Player: "
                                                        // name='Player'
                                                        options={
                                                            this.state.playerTypeOption
                                                        }
                                                        name='playerType'
                                                        value={this.state.playerType}
                                                        onChange={this.SelectPlayerDropChange}
                                                        
                                                    />
                                                </div> */}
                                                <div className="field_row horizontal_field">
                                                    <DropdownMaster
                                                        label="Access: "
                                                        options={
                                                            this.state.film && this.state.film.access
                                                        }
                                                        name='access'
                                                        value={this.state.access.value}
                                                        onChange={this.dropChange}
                                                        fpgerror={this.validator.message('access', this.state.access, 'required')}
                                                    />
                                                </div>
                                                
                                            </p>
                                            <div className="feature_title">
                                                <div className="field_row">
                                                    <TextField
                                                        type='text'
                                                        name="title" id="title"
                                                        value={this.state.title}
                                                        onChange={this.onInputChange}
                                                        placeholder="This is a film"
                                                    />
                                                    <span style={{ color: 'red' }}>{this.validator.message('title', this.state.title, 'required')}</span>
                                                </div>
                                                <div className="d_flex">
                                                    <div className="field_row editor_wrapper mr_15">
                                                        <div className="field_row_inner">
                                                            <label>Long Description (Detail Page)</label>
                                                            <div className="field_input relative">
                                                                <Editor
                                                                    wrapperClassName="sd_text_editor"
                                                                    editorState={this.state.editorState}
                                                                    onEditorStateChange={this.onEditorStateChange}
                                                                    toolbar={{
                                                                        blockType: {
                                                                            inDropdown: true,
                                                                            options: ['Normal', 'Blockquote'],
                                                                        },
                                                                        inline: { inDropdown: true },
                                                                        list: {
                                                                            inDropdown: true,
                                                                            options: ['unordered', 'ordered'],
                                                                        },
                                                                        textAlign: { inDropdown: true },
                                                                        link: { inDropdown: true },
                                                                        history: { inDropdown: true },
                                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign'],
                                                                    }}
                                                                    editorStyle={{ height: '210px' }}
                                                                />
                                                                <span style={{ color: 'red' }}>{this.validator.message('description', this.state.description, 'required')}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="wrap_selection_data">
                                                <div className="data_list relative zindex3">
                                                    <div className="field_row horizontal_field">
                                                        <Dropdown
                                                            label="Year"
                                                            name="year"
                                                            options={year}
                                                            value={this.state.year}
                                                            onChange={this.dropChangeCountryYear}
                                                            fpgerror={this.validator.message('year', this.state.year, 'required')}
                                                        />
                                                    </div>
                                                    {/* <span style={{ color: 'red' }}>{this.validator.message('year', this.state.year, 'required')}</span> */}

                                                    <div className="field_row horizontal_field">

                                                        <DropdownMaster
                                                            label="Category"
                                                            name="category"
                                                            options={
                                                                this.state.film && this.state.film.category
                                                            }
                                                            value={this.state.category.value}
                                                            onChange={this.dropChange}
                                                            fpgerror={this.validator.message('category', this.state.category, 'required')}
                                                        />
                                                        {/* <span style={{ color: 'red' }}>{this.validator.message('category', this.state.category, 'required')}</span> */}
                                                    </div>
                                                    {this.state.shortFlim && this.state.dropDownRemoveForIndiesSeries === false ?
                                                        <div className="field_row horizontal_field">
                                                            <DropdownMaster
                                                                label="&nbsp;"
                                                                name="shortProgramme1"
                                                                options={this.state && this.state.shortProgramme}
                                                                value={this.state.shortProgramme1.value}
                                                                onChange={(e) => this.dropChangeShortProgram(e)}
                                                            // fpgerror={this.validator.message('category', this.state.shortProgramme, 'required')}
                                                            />
                                                            {/* <span style={{ color: 'red' }}>{this.validator.message('category', this.state.category, 'required')}</span> */}
                                                        </div>
                                                        : ''}
                                                    <div className="field_row horizontal_field">
                                                        <Dropdown
                                                            label="Country"
                                                            options={countryType}
                                                            name="country"
                                                            value={this.state.country}
                                                            onChange={this.dropChangeCountryYear}
                                                            fpgerror={this.validator.message('country', this.state.country, 'required')}
                                                        />
                                                        {/* <TextField label="Country" 
                                                        name="country" id="country"
                                                        value={this.state.country}
                                                        onChange={this.onInputChange}
                                                        fpgerror={this.validator.message('country', this.state.country, 'required')}
                                                    /> */}
                                                        {/* <span style={{ color: 'red' }}>{this.validator.message('country', this.state.country, 'required')}</span> */}
                                                    </div>

                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Run Time</label>
                                                            <div className="field_input relative run_time_field">
                                                                <div>
                                                                    <input
                                                                        type="number"
                                                                        name="runTime"
                                                                        id="runTime"
                                                                        value={this.state.runTime}
                                                                        placeholder=""
                                                                        onChange={this.onInputChange}
                                                                    />
                                                                    <label>min</label>
                                                                </div>
                                                                {/* {fpgerror ? {fpgerror}</span> : ''} */}
                                                                <span className="error">{this.validator.message('runTime', this.state.runTime, 'required')}</span>
                                                            </div>
                                                        </div>


                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        <TextField label="Company"
                                                            name="company" id="company"
                                                            value={this.state.company}
                                                            onChange={this.onInputChange}
                                                        //  fpgerror={this.validator.message('company', this.state.company, 'companyName')}
                                                        />

                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        <TextField label="Website"
                                                            name="website" id="website"
                                                            value={this.state.website}
                                                            onChange={this.onInputChange}
                                                            fpgerror={this.validator.message('website', this.state.website, 'websiteValid')}

                                                        />
                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Genre</label>
                                                            <div className="select_field relative">
                                                                <Select
                                                                    isMulti
                                                                    onChange={this.handleChangeGenre}
                                                                    options={this.genreOption()}
                                                                    value={this.state && this.state.genre}
                                                                />
                                                            </div>
                                                        </div>
                                                        <span className="error select_error">{this.validator.message('genre', this.state.genre, 'required')}</span>
                                                    </div>
                                                    <div className="pb_15"></div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Interest Tracks</label>
                                                            <div className="select_field relative">
                                                                <Select
                                                                    isMulti
                                                                    onChange={this.handleChangenInterestTrack}
                                                                    options={this.interestTrackOption()}
                                                                    value={this.state && this.state.interestTrack}
                                                                />
                                                            </div>
                                                        </div>
                                                        <span className="error select_error">{this.validator.message('interest track', this.state.interestTrack, 'required')}</span>
                                                    </div>
                                                    <div className="field_row horizontal_field">
                                                        <div className="field_row_inner">
                                                            <label>Accessibility</label>
                                                            <div className="select_field relative">
                                                                <Select
                                                                    isMulti
                                                                    onChange={this.handleChangenAccessibility}
                                                                    options={this.accessibilityOption()}
                                                                    value={this.state && this.state.accessibility}

                                                                />
                                                            </div>
                                                        </div>
                                                        <span className="error select_error">{this.validator.message('accessibility', this.state.accessibility, 'required')}</span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div className="wrap_selection_data w_100 mt_0">

                                        {/* <div className="field_row horizontal_field">
                                            <div className="field_row_inner">
                                                <label>Audio Description</label>
                                                <div className="relative mt_10">
                                                    <div className="checkbox_field_row">
                                                        <div className="checkBox">
                                                            <input
                                                                type="checkbox"
                                                                id="isAudioDescription"
                                                                name="isAudioDescription"
                                                                checked={this.state.isAudioDescription}
                                                                onChange={(e) => this.handleCheck(e)} />
                                                            <label for="isAudioDescription" style={{ width: "auto" }}></label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="disp_flex ">
                                                    <label>Shift72 ID: </label>
                                                    <div className="field_input relative">
                                                        <input
                                                            type="text"
                                                            placeholder="123122"
                                                            name="audioDescriptionShift72Id"
                                                            value={this.state.audioDescriptionShift72Id}
                                                            onChange={this.onInputChange} />
                                                    </div>
                                                </div>
                                                
                                            </div>

                                        </div> */}
                                        <div className="field_row horizontal_field">
                                            <div className="field_row_inner">
                                                <label></label>
                                                <div className="relative mt_10">
                                                    <div className="checkbox_field_row">
                                                        <div className="checkBox">
                                                            {/* <input
                                                                type="checkbox"
                                                                id="isExplicitContent"
                                                                name="isExplicitContent"
                                                                checked={this.state.isExplicitContent}
                                                                onChange={(e) => this.handleCheck(e)} />
                                                            <label for="isExplicitContent" style={{ width: "auto" }}></label> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="disp_flex ">
                                                    <label>Eventive ID: </label>
                                                    <div className="field_input relative">
                                                        <input
                                                            type="text"
                                                            placeholder="123122"
                                                            name="audioDescriptionEventiveId"
                                                            value={this.state.audioDescriptionEventiveId}
                                                            onChange={this.onInputChange} />
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <div className="field_row_inner">
                                                <label>Explicit Content</label>
                                                <div className="relative mt_10">
                                                    <div className="checkbox_field_row">
                                                        <div className="checkBox">
                                                            <input
                                                                type="checkbox"
                                                                id="isExplicitContent"
                                                                name="isExplicitContent"
                                                                checked={this.state.isExplicitContent}
                                                                onChange={(e) => this.handleCheck(e)} />
                                                            <label for="isExplicitContent" style={{ width: "auto" }}></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="field_row horizontal_field relative zindex2">
                                            <div className="field_row_inner">
                                                <label>Explicit Content Disclaimer</label>
                                                <div className="field_input relative editor_wrapper">
                                                    <Editor
                                                        wrapperClassName="sd_text_editor"
                                                        editorState={this.state.editorStateExplicitContent}
                                                        onEditorStateChange={this.onEditorStateChangeExplicitContent}
                                                        toolbar={{
                                                            blockType: {
                                                                inDropdown: true,
                                                                options: ['Normal', 'Blockquote'],
                                                            },
                                                            inline: { inDropdown: true },
                                                            list: {
                                                                inDropdown: true,
                                                                options: ['unordered', 'ordered'],
                                                            },
                                                            textAlign: { inDropdown: true },
                                                            link: { inDropdown: true },
                                                            history: { inDropdown: true },
                                                            options: ['inline', 'blockType', 'list', 'link', 'textAlign'],

                                                        }}
                                                        editorStyle={{ height: '250px' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="field_row horizontal_field pt_15 pb_15 event_link_field event_link_field_qa">
                                            <TextField
                                                label="QA Link"
                                                placeholder="https://video.com"
                                                name="qaReplayLink" id="qaReplayLink"
                                                value={this.state.qaReplayLink}
                                                onChange={this.onInputChange}
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('qa Link', this.state.qaReplayLink, 'urlValidation')}</span>
                                        </div> */}
                                        <div className="field_row horizontal_field">
                                            <TextField
                                                label="Screening More info Title"
                                                placeholder="Type to lookup sponsor and hit enter to add"
                                                type="text"
                                                name="screeningMoreInfoTitle" id=""
                                                value={this.state.screeningMoreInfoTitle}
                                                onChange={this.onInputChange}
                                            />
                                        </div>

                                        <div className="field_row horizontal_field">
                                            <div className="field_row_inner">
                                                <label>Screening - More Info</label>
                                                <div className="field_input relative editor_wrapper">
                                                    <Editor
                                                        wrapperClassName="sd_text_editor"
                                                        editorState={this.state.editorStateScreeningMoreInfo}
                                                        onEditorStateChange={this.onEditorStateChangeScreeningMoreInfo}
                                                        toolbar={{
                                                            blockType: {
                                                                inDropdown: true,
                                                                options: ['Normal', 'Blockquote'],
                                                            },
                                                            inline: { inDropdown: true },
                                                            list: {
                                                                inDropdown: true,
                                                                options: ['unordered', 'ordered'],
                                                            },
                                                            textAlign: { inDropdown: true },
                                                            link: { inDropdown: true },
                                                            history: { inDropdown: true },
                                                            options: ['inline', 'blockType', 'list', 'link', 'textAlign'],

                                                        }}
                                                        editorStyle={{ height: '250px' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>


                                    </div>


                                </div>
                                <div className="text_center field_row w_100 buttons_outer">
                                    <button className="uppercase" type='button' onClick={(e) => this.cancelFilmLit(e)}>CANCEL</button>
                                    {/* {this.state.filmId &&
                                    <button className="uppercase prev_btn" type='button' onClick={(e)=>this.previewRecord(e)}>PREviEW</button>
                                } */}
                                    <button className="uppercase active" type='button' onClick={(e) => this.submitFilm(e)} disabled={this.state.filmDisabled ? true : false}>SAVE</button>
                                </div>
                            </div>
                        </form>
                        {this.state.messageModal &&
                            <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
                        }

                        {this.state.errorPopup ?
                            <ErrorPopUp
                                errorMsg={this.state.errorMsg}
                                errorMsgPopup={() => this.setState({
                                    errorPopup: false,
                                    errorMsg: ''
                                })}
                            />
                            : ''
                        }
                        {this.state.deleteImagePopup ? (
                            <PopUpCustomAll
                                HeaderName="Delete Image?"
                                insideDetails="Are You Sure ?"
                                insideData="You want to delete this image"
                                popupState={this.closeAdminUser}
                                yesPopUp={this.onDeleteImagePopup}
                            />
                        ) : (
                                ""
                            )}
                        {this.state.discardPopup ? (
                            <PopUpCustomAll
                                HeaderName="Discard Changes?"
                                insideDetails="Leaving this page without saving will discard all changes"
                                insideData="Do you want to proceed?"
                                popupState={this.closeAdminUser}
                                yesPopUp={() => this.discardPopupYes()}
                            />
                        ) : (
                                ""
                            )}
                    </div>
                </div>
            </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateFilm)
